// For a simpler UI, sorting & filter fields displayed in the same list>,
// without differentiating the fact that sorting != filtering.
//
// Sorting fields
export const LIST_TYPE_VOTES = 'votes'
export const LIST_TYPE_DATE = 'date'
// TODO: Add a "Completed" listType filter?
// Filter fields
export const LIST_TYPE_PENDING = 'pending'
export const LIST_TYPE_USER = 'user'
export const LIST_TYPE_BROADCASTER_LIKES = 'broadcasterLikes'
export const LIST_TYPE_BROADCASTER_POSTS = 'broadcasterPosts'
export const LIST_TYPE_CONTROVERSIAL = 'voteControversy'
export const LIST_TYPE_UNREAD = 'unread'
export const LIST_TYPE_ARCHIVED = 'archived'

export const SORT_ASC = 'asc'
export const SORT_DESC = 'desc'

export const VOTE_UP = 'upVote'
export const VOTE_DOWN = 'downVote'
export const VOTE_NONE = 'noVote'

// A suggestion submission's status.
// TODO: Add the STATUS_ prefix to these 3. You'll need to update
// the database too... Low priority.
export const STATUS_APPROVED = 'APPROVED'
export const STATUS_DELETED = 'DELETED'
export const STATUS_PENDING = 'PENDING'
export const STATUS_ARCHIVED = 'ARCHIVED'
export const STATUS_PENDING_AUTOMOD = 'STATUS_PENDING_AUTOMOD'
// Suggestion is private to all users, including the streamer,
// until the streamer grants permission
export const STATUS_PENDING_OAUTH_TOKEN = 'STATUS_PENDING_OAUTH_TOKEN'
export const STATUS_CHAT_BANNED = 'STATUS_CHAT_BANNED'
export const STATUS_CHAT_TIMED_OUT = 'STATUS_CHAT_TIMED_OUT'
// user submitted a post before post cooldown was complete.
// can occur if user is on page && streamer changes cooldown
export const STATUS_COOLDOWN_DENIED = 'COOLDOWN_DENIED' // TODO: Add the STATUS_ prefix
export const STATUS_PROFANITY_DENIED = 'STATUS_PROFANITY_DENIED'
export const STATUS_LINK_DENIED = 'STATUS_LINK_DENIED'

export const PENDING_STATUS_TYPES = [STATUS_PENDING, STATUS_PENDING_AUTOMOD]

export const STATUS_TYPES_THAT_USERS_CAN_SET = [
    STATUS_APPROVED,
    STATUS_DELETED,
    STATUS_PENDING,
    STATUS_ARCHIVED,
    // Users can only set this status with an "undo" action, like
    // undoing a DELETE that sets the status back to AUTOMOD.
    STATUS_PENDING_AUTOMOD,
]

// Mock value for the "handledByUserId" suggestion field.
export const OAUTH_HANDLER_MOCK_ID = 'oauth_pending'

export const HEADER_IMAGE_MAX_SIZE = 1024 * 1024 * 3 // 3MB

export const SUGGESTION_MAX_LENGTH = 300
export const MESSAGE_TO_VIEWER_MAX_LENGTH = 1000
export const TITLE_MAX_LENGTH = 100
// This should be less than MAX_UNIQUE_EMOTES_PER_SUGG, to prevent
// a single user from consuming the unique emote limit.
export const MAX_EMOTES_PER_SUGG_PER_USER = 15
// TODO: FInd a reasonable number that doesn't destroy the UI/UX
// Or Let them go crazy? This is twitch, all users do is emote.
export const MAX_UNIQUE_EMOTES_PER_SUGG = 40

// Fixes "An <img> element was lazyloaded with loading=lazy, but had no
// dimensions specified. Specifying dimensions improves performance.
// See https://crbug.com/954323"
export const EMOTE_SIZE_IN_PICKER = 28
export const EMOTE_SIZE_IN_REACTION = 20

export const PUBSUB_SUGGESTION = 'PUBSUB_SUGGESTION'
export const PUBSUB_VOTE = 'PUBSUB_VOTE'
export const PUBSUB_EMOTE = 'PUBSUB_EMOTE'

export const BTTV = 'BTTV'
export const BTTV_GLOBAL = 'BTTV_GLOBAL'
export const BTTV_TOP = 'BTTV_TOP'
export const BTTV_TRENDING = 'BTTV_TRENDING'
export const BTTV_CHANNEL = 'BTTV_CHANNEL'
// Ignore this category for now, doesn't seem to return popular emotes.
export const BTTV_SHARED = 'BTTV_SHARED'
export const BTTV_CACHE_DURATION_MS = 1000 * 60 * 60 * 24 // 1 day.

export const OAUTH_ASK_PERMISSION = 'OAUTH_ASK_PERMISSION'
export const OAUTH_AWAITING_ACTION = 'OAUTH_AWAITING_ACTION'
// User closed popup window without giving or denying permission.
export const OAUTH_NO_ACTION = 'OAUTH_NO_ACTION'
export const OAUTH_ERROR = 'OAUTH_ERROR'
export const OAUTH_DENIED = 'OAUTH_DENIED'
export const OAUTH_SUCCESS = 'OAUTH_SUCCESS'
export const OAUTH_LOCAL_STORAGE_KEY = 'grantTimestamp'

// Generic constants that can be used for state machines
export const STATE_DEFAULT = 'STATE_DEFAULT'
export const STATE_LOADING = 'STATE_LOADING'
export const STATE_SUCCESS = 'STATE_SUCCESS'
export const STATE_ERROR = 'STATE_ERROR'

export const ASYNC_STATES = {
    STATE_DEFAULT,
    STATE_LOADING,
    STATE_SUCCESS,
    STATE_ERROR,
}

// Never expires
export const DISCORD_INVITE_LINK = 'https://discord.gg/yMPTYp6'
